import axios from 'axios';
import cookie from '../lib/cookie/cookie';
import getAppConfiguration from '../appConfiguration';
import { getCurrentLocale } from '../../utils/localization';

const AccessTokenKey = 'nlab_token';
const RefreshTokenKey = 'nlab_refresh_token';

const appConfig = getAppConfiguration();
const { locale } = appConfig;

const cookieOptions = {
	path: '/',
};

export const clearAuthCookies = () => {
	cookie.remove(AccessTokenKey, cookieOptions);
	cookie.remove(RefreshTokenKey, cookieOptions);
};

export const getAccessToken = () => {
	return cookie.get(AccessTokenKey, cookieOptions);
};

export const getRefreshToken = () => {
	return cookie.get(RefreshTokenKey, cookieOptions);
};

export const setAccessTokens = (accessToken, refreshToken) => {
	const date = new Date();
	date.setTime(date.getTime() + 24 * 60 * 60 * 1000);

	cookie.set(AccessTokenKey, accessToken, {
		...cookieOptions,
		expires: date,
	});
	cookie.set(RefreshTokenKey, refreshToken, {
		...cookieOptions,
		expires: date,
	});
};

export const authRequestInterceptor = (config) => {
	const accessToken = getAccessToken();
	config.headers = {
		...config.headers,
		'APP-LOCALE': locale,
		Authorization: accessToken ? 'Bearer ' + accessToken : null,
	};
	return config;
};

export const publicRequestInterceptor = (config) => {
	config.headers = {
		...config.headers,
		'APP-LOCALE': locale,
	};
	return config;
};

export const commonResponseSuccessInterceptor = (response) => {
	return response;
};

export const commonErrorInterceptor = (error) => {
	return Promise.reject(error);
};

export const getLogoutUrl = () => {
	return window.location.origin + '/' + getCurrentLocale() + '/logout';
};

export const redirectToLogoutPage = () => {
	window.location.href = getLogoutUrl();
};

const handleRefreshToken = (res, originalRequest) => {
	if (res.status === 200) {
		const new_access_token = res.data.access_token;
		const new_refresh_token = res.data.refresh_token;
		// 1) put token to Cookie
		clearAuthCookies();
		setAccessTokens(new_access_token, new_refresh_token);

		// 2) Change Authorization header
		axios.defaults.headers.common['Authorization'] = 'Bearer ' + new_access_token;
		originalRequest.headers['Authorization'] = 'Bearer ' + new_access_token;

		// 3) return originalRequest object with Axios.
		return axios(originalRequest);
	}
};

let refreshTokensPromise = null;

export const handleAxiosRefreshTokenGeneration = (error) => {
	const originalRequest = error.config;
	if (error && error.response && error.response.status === 401 && !originalRequest._retry) {
		const refreshToken = getRefreshToken();

		if (!refreshToken) {
			clearAuthCookies();
			redirectToLogoutPage();
			return;
		}

		if (refreshTokensPromise) {
			return refreshTokensPromise;
		}

		refreshTokensPromise = axios
			.post('/nauth/npanel/refresh_token', {
				refresh_token: refreshToken,
			})
			.then((res) => {
				refreshTokensPromise = null;
				return handleRefreshToken(res, originalRequest);
			})
			.catch((refreshTokenError) => {
				refreshTokensPromise = null;
				console.log('in catch block', refreshTokenError);
				clearAuthCookies();
				redirectToLogoutPage();
				return Promise.reject(error);
			});
		return refreshTokensPromise;
	} else {
		return Promise.reject(error);
	}
};

export function addAuthRequestResponseInterceptor(axiosClient) {
	axiosClient.interceptors.request.use(authRequestInterceptor, commonErrorInterceptor);

	// Add a response interceptor
	axiosClient.interceptors.response.use(commonResponseSuccessInterceptor, handleAxiosRefreshTokenGeneration);
}
